export const unique = (arr: any[]) => [...new Set(arr)];
